import React, {Component} from 'react'

import styled from '@emotion/styled'
import queryString from 'query-string'

import GistPlayer from '../components/player/GistPlayer'
import {getMedia} from "../defaults/resourceLinker";

// STYLE ##########################################################
const Content = styled(`div`)`
    position: absolute;
    width: 100%;
    height: 100%;
`;

// COMPONENT ##########################################################

class Embed extends Component {

    state = {
        sourceError: '',
    };

    componentDidMount() {
        this.fetchSource();
    }
    
    componentWillUnmount() {}
    
    fetchSource = () => {
        let uuid = this.props.match.params.uuid;
        if (uuid) {
            getMedia(uuid).then(res => {    // fetch for source based on uuid
                if (res) {
                    this.setState({ sourceInfo: res });
                }
            }).catch(error => {
                this.setState({ sourceError: error.errorMsg })
            })
        }
    };

    render() {
        const {version} = queryString.parse(this.props.location.search);
        const {sourceInfo, sourceError} = this.state;
        return (
            <Content>
                <GistPlayer
                    videoId={this.props.match.params.uuid}  // UUID
                    version={version}                       // gist algorithm version
                    dat={sourceInfo}
                    key={sourceInfo}
                    errorMessage={sourceError}
                    isEmbedded={true}
                />
            </Content>
        )
    }

}

export default Embed
